import { Input } from 'antd'
import styled from 'styled-components'

const inputFieldStyles = `
  border: 1px solid #bdbdbd;
  background: var(--light-grey-input-fields-forms, #f6f6f6);
  &:hover {
    border: 1px solid #bdbdbd;
  }
  &:focus-within {
    border: 2px solid #ed6928;
  }
`

export const AntInput = styled(Input)`
  ${inputFieldStyles}
`

export const AntPasswordInput = styled(Input.Password)`
  ${inputFieldStyles}
`
